import { getColor, getSourceColor } from '../colorGenerator';

const getDoughnutGraphDataSet = dataArray => ({
    backgroundColor: dataArray.map((ith, index) => getColor(index, 1)),
    borderColor: 'rgba(255,255,255,1)',
    borderWidth: 2,
    data: dataArray.map(data => data.count),
});

const getSourceDoughnutGraphDataSet = dataArray => ({
    backgroundColor: dataArray.map(ith => getSourceColor(ith.name, 1)),
    borderColor: 'rgba(255,255,255,1)',
    borderWidth: 2,
    data: dataArray.map(data => data.count),
});

const mapSourceToDoughnutGraph = (sourceData, totalCount, translation) => {
    sourceData.sort((a, b) => b.name.localeCompare(a.name));
    const labels = sourceData.map(source => `${translation.SOURCE_KEYS[source.name] || source.name} ${Math.round(source.count * 100 / totalCount)}%`);
    const datasets = [getSourceDoughnutGraphDataSet(sourceData)];

    return {
        labels,
        datasets,
    };
};

const mapPageToDoughnutGraph = (pageData, totalCount, translation) => {
    pageData.sort((a, b) => a.name.localeCompare(b.name));
    const labels = pageData.map(page => `${translation.PAGE_KEYS[page.name] || page.name} ${Math.round(page.count * 100 / totalCount)}%`);
    const datasets = [getDoughnutGraphDataSet(pageData)];

    return {
        labels,
        datasets,
    };
};

const mapCustomerToDoughnutGraph = (customerCount, totalCount, translation) => {
    const nonCustomerCount = totalCount - customerCount;

    const labels = [
        `${translation.CUSTOMER} ${Math.round(customerCount * 100 / totalCount)}%`,
        `${translation.NONCUSTOMER} ${Math.round(nonCustomerCount * 100 / totalCount)}%`,
    ];

    const datasets = [
        getDoughnutGraphDataSet(
            [
                { count: customerCount },
                { count: nonCustomerCount },
            ],
        ),
    ];

    return {
        labels,
        datasets,
    };
};

const mapLeadOriginToDoughnutGraph = (leadOrigin, translation) => {
    leadOrigin.sort((a, b) => b.count - a.count);
    const totalCount = leadOrigin.reduce((result, obj) => result + obj.count, 0);

    const labels = leadOrigin.map(origin => `${translation.PRODUCT_KEYS[origin.name] || origin.name} ${Math.round(origin.count * 100 / totalCount)}%`);

    const datasets = [getDoughnutGraphDataSet(leadOrigin)];

    return {
        labels,
        datasets,
    };
};

export {
    mapSourceToDoughnutGraph,
    mapPageToDoughnutGraph,
    mapLeadOriginToDoughnutGraph,
    mapCustomerToDoughnutGraph,
};
